<template>
  <div>
    <div class="modal-title text-xl tenant-main-color font-semibold mb-2">
      About Course
    </div>
    <div class="flex flex-row flex-wrap">
      <div class="w-full my-3 md:w-1/2 flex">
        <div class="mx-2 mt-2 modal-field font-semibold">Title:</div>
        <div class="flex-grow ml-auto">
          <linput
            type="text"
            name="fname"
            v-model="form.title"
            :errorMessage="errors.title"
            :error="errors.title"
            placeholder="Title of Course"
          />
        </div>
      </div>

      <div class="w-full my-3 md:w-1/2 flex">
        <div class="mx-2 mt-2 modal-field font-semibold">Caption:</div>
        <div class="flex-grow ml-auto">
          <linput
            type="text"
            name="fname"
            v-model="form.caption"
            :errorMessage="errors.caption"
            :error="errors.caption"
            placeholder="e.g The course in 10 words"
          />
        </div>
      </div>

      <div class="w-full my-3 md:w-1/2 flex">
        <div class="mx-2 mt-2 modal-field font-semibold">Duration:</div>
        <div class="flex-grow ml-auto">
          <linput
            type="text"
            v-model="form.duration"
            :errorMessage="errors.duration"
            :error="errors.duration"
            placeholder="e.g 20 days"
          />
        </div>
      </div>

      <div class="w-full my-3 md:w-1/2 flex">
        <div class="mx-2 mt-2 modal-field font-semibold">Select Program:</div>
        <div class="flex-grow ml-auto">
          <lselect
            :error="errors.type"
            v-model="id"
            :items="getPrograms"
            :errorMessage="errors.type"
            placeholder="Select Program"
          />
        </div>
      </div>

      <div class="w-full my-3 md:w-1/2 flex">
        <div class="mx-2 mt-2 modal-field font-semibold">
          Course Instructor:
        </div>
        <div class="flex-grow ml-auto">
          <linput
            type="text"
            v-model="form.course_instructor"
            :errorMessage="errors.course_instructor"
            :error="errors.course_instructor"
            placeholder="e.g Jane Doe"
          />
        </div>
      </div>

      <div class="w-full my-3 md:w-1/2 flex">
        <div class="mx-2 mt-2 modal-field font-semibold">Overview Video:</div>
        <div class="flex-grow ml-auto">
          <lselect
            selected
            :error="errors.course_video"
            v-model="form.course_video"
            :errorMessage="errors.course_video"
            :items="getResources"
            placeholder="Select Overview Video"
          />
        </div>
      </div>
      <div class="flex flex-col flex-wrap flex-grow items-start mr-12">
        <div class="flex flex-row flex-wrap items-center form-row mb-8"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapActions, mapGetters } from "vuex";
import FormActions from "@/mixins/FormActions";
import { mapActions } from "vuex";
import Quill from "quill";
export default {
  mixins: [FormActions],
  components: {
    linput: () => import("@/components/general/input"),
    ltextarea: () => import("@/components/general/textarea"),
    LmsButton: () => import("@/components/general/button"),
    lselect: () => import("@/components/forms/select"),
    lCourseInitial: () => import("@/components/tenant/courses/course-initial"),
  },
  mounted() {
    let options = {
      // debug: "info",
      placeholder: "Create an article...",
      theme: "snow",
      modules: {
        toolbar: {
          container: [
            [{ header: [1, 2, 3, 4, 5, false] }],
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            ["image", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
          ],
        },
      },
    };
    this.editor = new Quill(this.$refs.editor, options);
  },
  data() {
    return {
      showAssets: false,
      editor: "",
      payment: [
        {
          text: "Free",
          value: "free",
        },
        {
          text: "Paid",
          value: "paid",
        },
        {
          text: "Coupon",
          value: "coupon",
        },
      ],
      currency: [
        {
          text: "Naira",
          value: "NGN",
        },
        {
          text: "Dollars",
          value: "DOL",
        },
      ],
      pacing: [
        {
          text: "Self-Paced",
          value: "self",
        },
        {
          text: "Fixed Timed",
          value: "fixed",
        },
      ],
      publish: [
        {
          text: "Published",
          value: "published",
        },
        {
          text: "Draft",
          value: "draft",
        },
      ],
      errors: [],
      form: {},
    };
  },
};
</script>

<style scoped></style>
